import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import BriefDetails from "../components/BriefDetails";
import { useLocation } from "react-router-dom";

function AssemblyElectionDetails() {
  const [assemblies, setAssemblies] = useState([]);
  const [selectedAssembly, setSelectedAssembly] = useState(null);
  const location = useLocation();

  const yearSelectedValue = location.state?.yearSelectedValue || null;
  const firstDropDownValue = location.state?.firstDropDownValue || null;
  const secondDropDownValue = location.state?.secondDropDownValue || null;

  useEffect(() => {
    if (yearSelectedValue && firstDropDownValue)
      setSelectedAssembly(firstDropDownValue);
  }, []);

  useEffect(() => {
    async function fetchAssemblies() {
      const response = await dataService.getAssemblyBasedAdmin();
      setAssemblies(response.data);
    }
    fetchAssemblies();
  }, []);

  return (
    <BriefDetails
      title="Assembly Details"
      primaryDropdownLabel="Select Assembly"
      primaryDropdownData={assemblies}
      primaryDropdownValue={selectedAssembly}
      onPrimarySelect={setSelectedAssembly}
      hasSecondaryDropdown={false}
      id={selectedAssembly}
      yearSelected={yearSelectedValue}
    />
  );
}

export default AssemblyElectionDetails;
